module.exports = __webpack_public_path__ + "img/new_39.2e5989aa.jpg";